import { ITenantContextProps } from "@hopper-b2b/utilities";
import { lightModeIcons } from "./assets/icons";
import { lightModeImages } from "./assets/images";

export const tenantContext: ITenantContextProps = {
  icons: lightModeIcons,
  images: lightModeImages,
};
